const routes = {
  settings: '/locations/:locationId',
  privateGuard: '/locations/:locationId/private-guard',
  alerts: '/locations/:locationId/alerts',
  devices: '/locations/:locationId/devices',
  trialManagement: '/locations/:locationId/trial-management',
  trialBenefits: '/locations/:locationId/trial-management/benefits',
  locations: '/locations',
  dashboard: '/dashboard',
  onboard: '/onboard',
  freeTrialCanceled: '/free-trial-canceled',
  root: '/',
  signOut: '/signout',
  onboarding: '/onboarding',
  onboardingIntroduction: '/onboarding/:locationId',
  onboardingAlertPreferences: '/onboarding/:locationId/alert-preferences',
  onboardingEmergencyContacts: '/onboarding/:locationId/emergency-contacts',
  onboardingProfessionalMonitoring: '/onboarding/:locationId/professional-monitoring',
  onboardingSOSTurnOn: '/onboarding/:locationId/sos-turn-on',
  onboardingSOSSetUp: '/onboarding/:locationId/sos-set-up',
  onboardingSetupComplete: '/onboarding/:locationId/setup-complete',
  onboardingHowVSGWorks: '/onboarding/:locationId/how-vsg-works',
  onboardingError: '/onboarding/:locationId/onboarding-error',
  onboardingEventsAndPrivacy: '/onboarding/:locationId/events-and-privacy',
  onboardingLocation: '/location',
  onboardingDevices: '/onboarding/:locationId/device-authorization',
  onboardingPracticeMode: '/onboarding/:locationId/practice-mode',
  returnTo: '/return_to',
  freeTrial: '/locations/:locationId/free-trial',
  upsell: '/video-monitoring/experience-more',
  eventSummary: '/locations/:locationId/events-summary',
  honeypot: '/signin',
};

const apiRoutes = {
  session: '/api/neighbors/session/verify',
  allDevices: (userId, locationId) => `/api/neighbors/${userId}/locations/${locationId}/devices`,
  allLocations: (userId) => `/api/neighbors/${userId}/locations`,
  contacts: (userId, locationId) => `/api/neighbors/${userId}/locations/${locationId}/contacts`,
  features: (principalDomain, principal) => `/api/features?principalDomain=${principalDomain}&principal=${principal}`,
  preferences: (userId, locationId) => `/api/neighbors/${userId}/locations/${locationId}/preferences`,
  subscribe: (userId) => `/api/neighbors/${userId}/devices`,
  subscription: (userId, locationId) => `/api/subscription/${userId}/locations/${locationId}`,
  unsubscribe: (userId, doorbotId) => `/api/neighbors/${userId}/devices/${doorbotId}`,
  unsubscribeLocation: (userId) => `/api/subscription/${userId}`,
  sendStats: (userId) => `/api/stats/user/${userId}/action`,
  monitoringStatus: (userId, locationId) => `/api/neighbors/${userId}/locations/${locationId}/monitoring/status`,
  status: (userId, locationId) => `/api/neighbors/${userId}/locations/${locationId}/status`,
  entitlement: (userId, locationId) => `/api/neighbors/${userId}/locations/${locationId}/entitlement`,
  events: (userId, locationId, startTime, limit, nextToken, resolutionTypes) =>
    `/api/neighbors/${userId}/events/history?startTime=${startTime}&limit=${limit}${locationId ? `&locationId=${locationId}` : ''}${
      nextToken ? `&nextToken=${nextToken}` : ''
    }${resolutionTypes ? `&resolutionTypes=${resolutionTypes}` : ''}`,
  eventSummary: (userId, locationId) => `/api/neighbors/${userId}/locations/${locationId}/events/summary`,
  eventsTimeseries: (userId, locationId, resolutionTypes) =>
    `/api/neighbors/${userId}/events/timeseries?interval=day${resolutionTypes ? `&resolutionTypes=${resolutionTypes}` : ''}${
      locationId ? `&locationId=${locationId}` : ''
    }`,
  completeOnboarding: (userId, locationId) => `/api/neighbors/${userId}/locations/${locationId}/onboarding`,
  onboardingComplete: (userId, locationId) => `/api/neighbors/${userId}/locations/${locationId}/onboarding-complete`,
  endAlarmPractice: (userId, locationId) => `/api/neighbors/${userId}/locations/${locationId}/endalarmpractice`,
  state: (userId, locationId) => `/api/neighbors/${userId}/locations/${locationId}/state`,
  allLocationsStatus: (userId) => `/api/neighbors/${userId}/status`,
  guard: (userId, locationId) => `/api/neighbors/${userId}/locations/${locationId}/guard`,
};

export { routes, apiRoutes };
